import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import './Layout.css';

const Header = ({ toggleSideNav }) => {
    const { currentUser, userData, isAdmin, logout } = useAuth();
    const navigate = useNavigate();

    const getInitials = () => {
        if (userData?.firstName) {
            return userData.firstName.charAt(0).toUpperCase();
        }
        if (userData?.fullName) {
            return userData.fullName.charAt(0).toUpperCase();
        }
        return 'U';
    };

    const getAvatarColor = (initials) => {
        const colors = [
            '#1034A6', '#0c2a7a', '#28a745', '#dc3545', 
            '#ffc107', '#6f42c1', '#17a2b8', '#20c997',
            '#fd7e14', '#e83e8c'
        ];
        const index = initials.charCodeAt(0) % colors.length;
        return colors[index];
    };

    return (
        <header className="header">
            <button className="menu-btn" onClick={toggleSideNav} aria-label="Toggle menu">
                <i className="fas fa-bars"></i>
            </button>
            
            <div className="logo-container" onClick={() => navigate('/')}>
                <img src="/Logo1.png" alt="White Doves Ministry Logo" className="logo-img" 
                     onError={(e) => e.target.style.display = 'none'} />
                <div className="ministry-name">WHITE DOVES MINISTRY</div>
            </div>
            
            <div className="user-menu">
                {isAdmin && <span className="admin-badge">ADMIN</span>}
                <div className="user-avatar" title="Profile">
                    {userData?.photoURL ? (
                        <img 
                            src={userData.photoURL} 
                            alt="Profile" 
                            className="user-avatar-img"
                            onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.parentElement.style.backgroundColor = getAvatarColor(getInitials());
                                e.target.parentElement.textContent = getInitials();
                            }}
                        />
                    ) : (
                        <span style={{ 
                            backgroundColor: getAvatarColor(getInitials()),
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            {getInitials()}
                        </span>
                    )}
                </div>
            </div>
        </header>
    );
};

export default Header;
